var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"disco-area",style:({ backgroundColor: ("hsl(" + _vm.x + ", 80%, 50%)") }),on:{"mousemove":_vm.xCoordinate}},[_c('h3',[_vm._v("Move your mouse across the screen and enjoy the party...")])])}
var staticRenderFns = []

export { render, staticRenderFns }